import React, { Component } from 'react';
import { Loader } from 'react-loaders';

import { batchRequest, getRequest } from '../../../../../../api/ApiService';

import {
  Wrapper,
  PreTitle,
  Title,
  Text,
  ContentContainer,
  Charts
} from '../../../components/ui';
import SelectorWrapper from '../../../components/selector-wrapper';

import Chart from '../../../components/peer-rating-chart';

const chartColors = [
  '#52C5CD',
  '#D9DDE2',
  '#9EA8B4'
];

class PeerRating extends Component {
  constructor(props) {
    super(props);

    this.state = {
      chartData: [],
      defaultChartData: [],
      isBarChart: false,
      isLineChart: false,
      selectedUserId: 0,
      loaded: false
    };
  }

  async componentDidMount() {
    const {
      finishedSurveys,
      surveysStatsByUser,
      surveysStatsByTeam
    } = this.props;

    let chartData = [];
    let isBarChart = false;
    let isLineChart = false;

    const medianUserAverage = (surveysStatsByUser.reduce((total, next) => total + Number(next.median), 0) / surveysStatsByUser.length).toFixed(2);
    const medianteamAverage = (surveysStatsByTeam.reduce((total, next) => total + Number(next.average_over_median), 0) / surveysStatsByTeam.length).toFixed(2);
    const teamMedian = (surveysStatsByTeam.reduce((total, next) => total + Number(next.average_over_median), 0) / surveysStatsByTeam.length).toFixed(2);

    if (finishedSurveys.length === 1) {
      isBarChart = true;

      chartData = [
        {
          value: medianUserAverage,
          color: chartColors[0]
        },
        {
          value: medianteamAverage,
          color: chartColors[1]
        },
        {
          value: teamMedian,
          color: chartColors[2]
        }
      ];

      this.setState({
        chartData,
        defaultChartData: chartData,
        isBarChart,
        loaded: true
      });
    } else if (finishedSurveys.length > 1) {
      isLineChart = true;

      for (const finishedSurvey of finishedSurveys.slice(0, finishedSurveys.length - 1)) {
        await batchRequest([
          `${process.env.REACT_APP_API_URL}v2/forms/surveys/${finishedSurvey.id}/stats-by-user/`,
          `${process.env.REACT_APP_API_URL}v2/forms/surveys/${finishedSurvey.id}/stats-by-team/`,
        ])
          .then(res => {
            const surveyStatsByUser = res[0].body;
            const surveyStatsByTeam = res[1].body;

            const medianUserAverage = (surveyStatsByUser.reduce((total, next) => total + Number(next.median), 0) / surveyStatsByUser.length).toFixed(2);
            const medianteamAverage = (surveyStatsByTeam.reduce((total, next) => total + Number(next.average_over_median), 0) / surveyStatsByTeam.length).toFixed(2);
            const teamMedian = (surveysStatsByTeam.reduce((total, next) => total + Number(next.average_over_median), 0) / surveysStatsByTeam.length).toFixed(2);

            chartData.push({
              name: `${finishedSurvey.stage[0].toUpperCase()}${finishedSurvey.stage.slice(1)} Feedback`,
              student: medianUserAverage,
              teamAverage: medianteamAverage,
              teamMedian
            });
          })
          .catch(err => { })
      }

      chartData.push({
        student: medianUserAverage,
        teamAverage: medianteamAverage,
        teamMedian
      });

      this.setState({
        chartData,
        defaultChartData: chartData,
        isLineChart,
        loaded: true
      });
    }
  }

  get teamPlayersOptions() {
    const { gamesTeamplayers } = this.props;
    let options = gamesTeamplayers.map(gamesTeamplayer => (
      {
        id: gamesTeamplayer.user.id,
        name: `${gamesTeamplayer.user.first_name} ${gamesTeamplayer.user.last_name}`
      }
    ));

    const sortedOptions = [...options].sort((a, b) => a.name.localeCompare(b.name));

    sortedOptions.unshift({ id: 0, name: 'Overall' });
    return sortedOptions;
  }

  handleSelectChange = (value) => {
    const {
      currentFinishedSurvey,
      finishedSurveys
    } = this.props;

    const {
      defaultChartData,
      isBarChart,
      isLineChart
    } = this.state;

    if (value === 0) {
      this.setState({
        selectedUserId: value,
        chartData: defaultChartData,
        loaded: true
      });
    } else {
      this.setState({
        loaded: false,
        selectedUserId: value,
      });

      let chartData = [];

      if (isBarChart) {
        getRequest(
          `${process.env.REACT_APP_API_URL}v2/forms/score/${value}/${currentFinishedSurvey.id}/`,
        )
          .then(res => {
            const formsScore = res.body;
            chartData = [
              {
                value: formsScore.median_user_score.toFixed(2),
                color: chartColors[0]
              },
              {
                value: formsScore.team_average_score.toFixed(2),
                color: chartColors[1]
              },
              {
                value: formsScore.team_median_score.toFixed(2),
                color: chartColors[2]
              }
            ];

            this.setState({
              loaded: true,
              chartData
            });
          })
          .catch(err => { });
      } else if (isLineChart) {
        let requests = [];
        finishedSurveys.forEach(finishedSurvey => {
          requests.push(getRequest(`${process.env.REACT_APP_API_URL}v2/forms/score/${value}/${finishedSurvey.id}/`));
        });
        const formsScoreRequest = Promise.all(requests);

        formsScoreRequest
          .then(responses => {
            responses.forEach((res, index) => {
              const formsScore = res.body;
              chartData.push({
                name: `${finishedSurveys[index].stage[0].toUpperCase()}${finishedSurveys[index].stage.slice(1)} Feedback`,
                student: formsScore.median_user_score.toFixed(2),
                teamAverage: formsScore.team_average_score.toFixed(2),
                teamMedian: formsScore.team_median_score.toFixed(2)
              });
            });

            this.setState({
              loaded: true,
              chartData
            });
          })
          .catch(err => { });
      }
    }
  }

  render() {
    const {
      chartData,
      defaultChartData,
      isBarChart,
      isLineChart,
      selectedUserId,
      loaded
    } = this.state;

    const options = this.teamPlayersOptions;

    const medianUserAverage = isBarChart ? defaultChartData[0].value : 0;
    const medianteamAverage = isBarChart ? defaultChartData[1].value : 0;

    const title = isBarChart ? 'Peer rating in relation to Team’s' : 'Peer Rating Score Trend';
    const text = isBarChart
      ? <p>Here are your students peer rating scores in comparison to their teammates’. On average, the median rating that students receive from their peers were <b>{medianUserAverage}</b> out of 5 whereas the overall team’s median was <b>{medianteamAverage}</b> rating.</p>
      : <p>Here’s the change in your peer rating score.</p>;

    return (
      <Wrapper>
        <PreTitle>Individual</PreTitle>
        <Title>{title}</Title>
        <Text>{text}</Text>
        <SelectorWrapper
          label={'View'}
          options={options}
          onSelectorChange={this.handleSelectChange}
          selectedOptionId={selectedUserId}
        />
        {
          !loaded &&
          <Loader type="ball-scale-ripple" active />
        }
        {
          loaded &&
          <ContentContainer>
            <Charts.Teams.Wrapper>
              <Charts.Teams.Row>
                <Charts.Teams.TeamColor background={chartColors[0]} />
                <Charts.Teams.TeamName>Student</Charts.Teams.TeamName>
              </Charts.Teams.Row>
              <Charts.Teams.Row>
                <Charts.Teams.TeamColor background={chartColors[1]} />
                <Charts.Teams.TeamName>Team Average</Charts.Teams.TeamName>
              </Charts.Teams.Row>
              <Charts.Teams.Row>
                <Charts.Teams.TeamColor background={chartColors[2]} />
                <Charts.Teams.TeamName>Team Median</Charts.Teams.TeamName>
              </Charts.Teams.Row>
            </Charts.Teams.Wrapper>
            <Charts.Chart>
              <Chart
                data={chartData}
                isBarChart={isBarChart}
                isLineChart={isLineChart}
                chartColors={chartColors}
              />
            </Charts.Chart>
          </ContentContainer>
        }
      </Wrapper>
    );
  }

}

export default PeerRating;



// WEBPACK FOOTER //
// ./src/instructor/components/peer-feedback/pages/dynamics/individual/peer-rating.js